export default "__VITE_ASSET__CNRUQm85__"